/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Principalid1Inputs */

const en_entity_principalid1 = /** @type {(inputs: Entity_Principalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal ID`)
};

const de_entity_principalid1 = /** @type {(inputs: Entity_Principalid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal-ID`)
};

/**
* | output |
* | --- |
* | "Principal ID" |
*
* @param {Entity_Principalid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_principalid1 = /** @type {((inputs?: Entity_Principalid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Principalid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_principalid1(inputs)
	return de_entity_principalid1(inputs)
});
export { entity_principalid1 as "entity_principalId" }